function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#414141",
  d: "M15.143 5c0-2.757-2.307-5-5.143-5S4.857 2.243 4.857 5H1v11.875C1 18.601 2.44 20 4.214 20h11.572C17.56 20 19 18.6 19 16.875V5h-3.857zM10 1.25c2.127 0 3.857 1.682 3.857 3.75H6.143c0-2.068 1.73-3.75 3.857-3.75zm7.714 15.625c0 1.034-.865 1.875-1.928 1.875H4.214c-1.063 0-1.928-.841-1.928-1.875V6.25h2.571v1.875c0 .345.288.625.643.625.355 0 .643-.28.643-.625V6.25h7.714v1.875c0 .345.288.625.643.625.355 0 .643-.28.643-.625V6.25h2.571v10.625z"
});

var SvgShoppingCartInline = function SvgShoppingCartInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgShoppingCartInline;